export default "__VITE_ASSET__A6oIczfu__"